module.exports = __webpack_public_path__ + "img/tank2.cfd9713a.png";